type BrowserLocation = Pick<Location, 'host' | 'protocol'>

const webSocketProtocols = new Set(['ws:', 'wss:'])
const httpProtocols = new Set(['http:', 'https:'])

function appendGraphqlPath(value: string) {
  return `${value.replace(/\/+$/, '')}/graphql`
}

function parseAbsoluteUrl(value: string) {
  try {
    return new URL(value)
  } catch {
    return null
  }
}

export function buildGraphqlHttpUrl(configuredUrl: string | undefined, unsecure: boolean) {
  const baseUrl = configuredUrl?.trim()

  if (!baseUrl) {
    throw new Error('REACT_APP_API_URL must be configured')
  }

  const graphqlUrl = appendGraphqlPath(baseUrl)
  const absoluteUrl = parseAbsoluteUrl(graphqlUrl)

  if (absoluteUrl && httpProtocols.has(absoluteUrl.protocol)) {
    return graphqlUrl
  }

  if (graphqlUrl.startsWith('/')) {
    return graphqlUrl
  }

  return `${unsecure ? 'http' : 'https'}://${graphqlUrl}`
}

export function buildGraphqlWebSocketUrl(
  configuredUrl: string | undefined,
  unsecure: boolean,
  browserLocation: BrowserLocation = window.location
) {
  const baseUrl = configuredUrl?.trim()

  if (!baseUrl) {
    throw new Error('REACT_APP_API_WS_URL or REACT_APP_API_URL must be configured')
  }

  const graphqlUrl = appendGraphqlPath(baseUrl)
  const absoluteUrl = parseAbsoluteUrl(graphqlUrl)

  if (absoluteUrl && webSocketProtocols.has(absoluteUrl.protocol)) {
    return graphqlUrl
  }

  if (absoluteUrl && httpProtocols.has(absoluteUrl.protocol)) {
    absoluteUrl.protocol = absoluteUrl.protocol === 'https:' ? 'wss:' : 'ws:'
    return absoluteUrl.toString()
  }

  if (graphqlUrl.startsWith('/')) {
    const protocol = browserLocation.protocol === 'https:' ? 'wss:' : 'ws:'
    return `${protocol}//${browserLocation.host}${graphqlUrl}`
  }

  return `${unsecure ? 'ws' : 'wss'}://${graphqlUrl}`
}
